import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  OnDestroy,
  OnInit,
  OnChanges,
} from '@angular/core'
import { Router } from '@angular/router'
import moment from 'moment'
import { Subscription } from 'rxjs'
import { BlockerService } from 'src/app/modules/account/services/blocker.service'
import { getLoanInfoCleanTemp } from 'src/app/core/helpers/loanInfoUtils'
import { PageService } from 'src/app/core/services/page.service'
import { UserStateService, UserStateType } from 'src/app/core/services/user-state.service'
import { isBlock } from 'typescript'
import { LoanInfo } from '../../../../core/helpers/interfaces'
import { ModalOptionsFormComponent } from '../modal-options-form/modal-options-form.component'
import { SESSION_TIMER_MINUTES } from '../options-utils/modal-shared'
import { SharedDataService } from '../../../../core/services/shared-data.service'

@Component({
    selector: 'app-modal-options-main',
    templateUrl: './modal-options-main.component.html',
    styleUrls: ['../modal-options.component.scss'],
    standalone: false
})
export class ModalOptionsMainComponent implements OnInit, OnDestroy {
  @Output() dataSubmited: EventEmitter<unknown> = new EventEmitter()
  @Output() showLock: EventEmitter<any> = new EventEmitter()
  @Output() closeModal: EventEmitter<any> = new EventEmitter()
  @Output() toggleLoader: EventEmitter<any> = new EventEmitter()
  @Output() showOffers: EventEmitter<any> = new EventEmitter()

  @Input() FULL_DEV: any = false
  @Input() showLoader: boolean = false
  @Input() isCreditFreeze: any = false
  @Input() hooverPopupText = ''
  @Input() loanAcctId: any = null
  @Input() isMultiLoan = false
  @Input() isWelcomeBackContinue = false
  @Input() isWelcomeBack = false
  @Input() lastSessionDate: string
  @Input() isHawaiiMessage = false
  @Input() isDentistSelectBlock = false
  @Input() isMobileVerification = false
  @Input() breakpoints: any = {
    extraSmall: false,
    small: false,
    medium: false,
    large: true,
    extraLarge: true,
  }

  blockedError: any
  isSessionTimeout = false
  showHooverMenu = false
  loanInfo: LoanInfo = getLoanInfoCleanTemp()
  private _aSub: Subscription

  @ViewChild(ModalOptionsFormComponent) child: ModalOptionsFormComponent

  constructor(
    private _blocker: BlockerService,
    private router: Router,
    public userStateService: UserStateService,
    public sharedDataService: SharedDataService,
    public page: PageService
  ) {}

  ngOnInit(): void {
    // this.blockerCheck()
    // this._aSub = this._blocker.idBlocker$.subscribe((t) => this.blockerCheck())
  }

  ngOnDestroy() {
    this.userStateService.isInvalidState = false
    this.userStateService.isInvalidStateAmount = false
    this._aSub?.unsubscribe()
  }

  notifyFormSetInvalidAddressCauseState() {
    // this.toggleLoaderEvent(false)
    this.child.setInvalidAddressCauseState()
  }
  notifyFormSetInvalidPartsCauseAPIErrors() {
    // this.toggleLoaderEvent(false)
    this.child.setInvalidPartsCauseAPIErrors()
  }

  onSubmit(obj: { info: LoanInfo; coapp: boolean }) {
    this.toggleLoader.emit(true)
    this.userStateService.isInvalidState = this.userStateService.isInvalidStateAmount = false
    this.dataSubmited.emit(obj)
  }

  onClosed(e) {
    this.showHooverMenu = false
  }

  toggleLoaderEvent(bool) {
    this.toggleLoader.emit(bool)
  }

  // blockerCheck() {
  //   if (localStorage.getItem('blocker')) {
  //     let oldBlockerData = JSON.parse(localStorage.getItem('blocker'))
  //     if (oldBlockerData.blockedFor && !moment(moment.now()).isAfter(oldBlockerData.blockedFor)) {
  //       this.blockedError = true
  //     } else {
  //       this.blockedError = false
  //       // }
  //     }
  //   }
  // }

  onShowCreditLock() {
    this.showLock.emit(true)
  }

  onInfoIconTrigger(state: boolean, e: any) {
    if (
      ((e.type === 'mouseenter' || e.type === 'mouseleave') && !this.breakpoints.extraSmall) ||
      e.type === 'click'
    ) {
      this.showHooverMenu = state
    }
  }

  onWelcomeBackPopupClosed() {
    if(this.isWelcomeBackContinue){
      this.showOffers.emit(Math.random())
      return
    }
    this.isWelcomeBack = false
    this.isMultiLoan = false
    if (this.breakpoints.extraSmall) {
      this.page.goAndScroll('/', 'mobileHeader')
    } else {
      this.page.goAndScroll('/', 'topHeader')
    }
    this.closeModal.emit()
  }
  onHawaiiMessagePopupClosed() {
    this.isHawaiiMessage = false
  }

  onMobileValidationPopupClosed() {
    this.isMobileVerification = false
    this.userStateService.mobileCounter = 0
    this.child.setRunTimerByTimeout(SESSION_TIMER_MINUTES)
  }

  onSessionPopupToClose() {
    this.isSessionTimeout = false
    if (this.breakpoints.extraSmall) {
      this.page.goAndScroll('/', 'mobileHeader')
    } else {
      this.page.goAndScroll('/', 'topHeader')
    }
    this.closeModal.emit()
  }

  onSessionPopupContinue() {
    this.isSessionTimeout = false
    this.child.setRunTimerByTimeout(SESSION_TIMER_MINUTES)
  }

  showErrorPopup(e){
    this.userStateService.type =  e === 'hawaii' ? UserStateType.lessStateAmount : e === 'min' ? UserStateType.minLoanAmount : e === 'state' ? UserStateType.state : UserStateType.maxLoanAmount
    this.userStateService.isInvalidStateAmount = e === 'none' ? false : true
    setTimeout(()=>{
      this.userStateService.isInvalidStateAmount = false
    }, 5000)
    // this.userStateService.type = UserStateType.maxLoanAmount
  }

  showFormPopup(){
    this.isHawaiiMessage = true
  }
}
